import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import { trackPromise } from "react-promise-tracker";
import CachedIcon from "@material-ui/icons/Cached";

import DependentLogGrid from "./dependentLogGrid/DependentLogGrid";
import useRouteParam from "../../../../../../../../../hooks/useRouteParam";
import { UIContext } from "../../../../../../../../../contexts";
import { FindMemberActivityLogQueryTypes } from "../../../../../../../../../utils/api/member/get.memberActivityLogBySSN";
import { memberActivityLog } from "../../../../../../../../../@types/components/memberActivityProps.types";
import { api } from "../../../../../../../../../utils/api";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../../../constants/caption/dashboardHeader";
import { LoadingIndicator } from "../../../../../../../../../utils";

const DependentLogs: React.FC = (): JSX.Element => {
	const { setDashboardHeader } = useContext(UIContext);
	const queryGroupNumber = useRouteParam("gn");
	const querySSN = useRouteParam("qs");
	const [memberLogs, setMemberLogs] = useState<any[]>([]);
	const [refreshClick, setRefreshClick] = useState<boolean>(false);

	const handleRefreshClick = useCallback(async () => {
		setRefreshClick(true);
	}, []);

	const getMemberActivityLogBySSN = useCallback(async (SSN: string, group_number: number) => {
		const findMemberActivityLogQuery: FindMemberActivityLogQueryTypes = {
			group_number,
			SSN
		};

		const response: memberActivityLog = await trackPromise(
			api.member.getMemberActivityLogBySSN(findMemberActivityLogQuery)
		);

		if (response) {
			// console.log("Member Activity Logs: ", response);
			setMemberLogs(Object.assign([], response));
		}
	}, []);

	// console.log("memberLogs", memberLogs);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.dependent_activity_logs);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (querySSN && queryGroupNumber) {
			getMemberActivityLogBySSN(querySSN as string, queryGroupNumber as number);
		}
	}, [getMemberActivityLogBySSN, queryGroupNumber, querySSN]);

	useEffect(() => {
		if (querySSN && queryGroupNumber && refreshClick) {
			getMemberActivityLogBySSN(querySSN as string, queryGroupNumber as number);
			setRefreshClick(false);
		}
	}, [getMemberActivityLogBySSN, queryGroupNumber, querySSN, refreshClick]);

	return (
		<div>
			<div className="member-action-button-container" id="pf-action-button-container">
				<Button className="button-black" onClick={handleRefreshClick} variant="contained">
					<span className="button-label-with-icon">Refresh</span>
					<span>
						<CachedIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<div className="pf-title">Dependent Log Information</div>
			<div className="member-log-container" id="member-log-container">
				{refreshClick ? (
					<>
						<LoadingIndicator />
						<DependentLogGrid memberLogs={memberLogs} />
					</>
				) : (
					<DependentLogGrid memberLogs={memberLogs} />
				)}
			</div>
		</div>
	);
};

export default DependentLogs;
